import React from 'react';
import { IonRow, IonCol } from '@ionic/react';

import { ApplicationState } from '../store';
import { useHistory } from "react-router-dom";

import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as BasketStore from '../store/BasketStore';

import { simpleChannelType } from '../store/LocationStore';
import Button from './Button';

const MopFooterTablePage: React.FC = () => {
    const locationState = useSelector((state: ApplicationState) => state.location);
    const BasketTableNumber = useSelector((state: ApplicationState) => state.basket?.tableNumber);
    const BasketNickname = useSelector((state: ApplicationState) => state.basket?.nickname);
    const tableFormErrors = useSelector((state: ApplicationState) => state.basket?.tableFormErrors);
    const nicknameFormErrors = useSelector((state: ApplicationState) => state.basket?.nicknameFormErrors);

    const boundSetContinueClicked = bindActionCreators(BasketStore.actionCreators.setContinueClicked, useDispatch());
    const boundSetTableFormError = bindActionCreators(BasketStore.actionCreators.setTableFormErrors, useDispatch());
    const boundSetNicknameFormError = bindActionCreators(BasketStore.actionCreators.setNicknameFormErrors, useDispatch());
    const boundSetTableNumber = bindActionCreators(BasketStore.actionCreators.setTableNumber, useDispatch());
    const boundSetNickname = bindActionCreators(BasketStore.actionCreators.setNickname, useDispatch());
    const history = useHistory();

    if (localStorage.getItem('isLoggedIn') === "true") {
        if (!BasketNickname) {
            boundSetNicknameFormError("Please enter a valid Name or nickname");
        } else {
            boundSetNicknameFormError("");
        }
    }
    else {
        if (!BasketTableNumber) {
            boundSetTableFormError("Please enter a valid table number");
        } else {
            if (BasketTableNumber === 0) {
                boundSetTableFormError("Table number must be greater than 0");
            } else {
                boundSetTableFormError("");
            }
        }
    }

    const submitTableNumber = () => {
        boundSetContinueClicked(true)

        if (!tableFormErrors && !nicknameFormErrors) {
            boundSetTableNumber(BasketTableNumber as number);
            boundSetNickname(BasketNickname as string)
            history.push("/enteremail");
        }
    }

    return (
        <div className="MopFooterInner">
            <IonRow className="ion-align-items-center">
                <IonCol size="6" className="FooterStoreWrapper">
                    <span className="CollectFrom">{locationState?.selectedChannel === undefined ? "Store" : locationState.selectedChannel.channelType === simpleChannelType.ClickAndCollect ? "Take away" : "Eat in"}</span><br />
                    <span className="Location">{locationState?.selectedStore === undefined ? "Select a store" : locationState?.selectedStore.storeName}</span>
                    {locationState?.selectedStore?.takingMopOrders === false ? <span style={{ color: "#ff0" }}> - Order ahead not available</span> : null}
                </IonCol>
                <IonCol size="6">
                    <Button
                        onClick={submitTableNumber}
                        expand="block"
                        color="light"
                        size="small"
                        rounded
                    >
                        Continue
                    </Button>
                </IonCol>
            </IonRow>
        </div>
    );
};

export default MopFooterTablePage;
